/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { activitiesByUserId } from '../fn/user/activities-by-user-id';
import { ActivitiesByUserId$Params } from '../fn/user/activities-by-user-id';
import { ActivityResponse } from '../models/activity-response';
import { BooleanResponse } from '../models/boolean-response';
import { changeNewsletterStatus } from '../fn/user/change-newsletter-status';
import { ChangeNewsletterStatus$Params } from '../fn/user/change-newsletter-status';
import { changeNotificationsStatus } from '../fn/user/change-notifications-status';
import { ChangeNotificationsStatus$Params } from '../fn/user/change-notifications-status';
import { changeUserPassword } from '../fn/user/change-user-password';
import { ChangeUserPassword$Params } from '../fn/user/change-user-password';
import { countOfUnseenNewsFeedItems } from '../fn/user/count-of-unseen-news-feed-items';
import { CountOfUnseenNewsFeedItems$Params } from '../fn/user/count-of-unseen-news-feed-items';
import { findUsers } from '../fn/user/find-users';
import { FindUsers$Params } from '../fn/user/find-users';
import { galleryByUserId } from '../fn/user/gallery-by-user-id';
import { GalleryByUserId$Params } from '../fn/user/gallery-by-user-id';
import { getMe } from '../fn/user/get-me';
import { GetMe$Params } from '../fn/user/get-me';
import { getUserActiveSubscriptions } from '../fn/user/get-user-active-subscriptions';
import { GetUserActiveSubscriptions$Params } from '../fn/user/get-user-active-subscriptions';
import { getUserById } from '../fn/user/get-user-by-id';
import { GetUserById$Params } from '../fn/user/get-user-by-id';
import { getUserFollowingProfiles } from '../fn/user/get-user-following-profiles';
import { GetUserFollowingProfiles$Params } from '../fn/user/get-user-following-profiles';
import { getUserProfilesWhereIsAdmin } from '../fn/user/get-user-profiles-where-is-admin';
import { GetUserProfilesWhereIsAdmin$Params } from '../fn/user/get-user-profiles-where-is-admin';
import { getUserProfilesWhereIsAuditor } from '../fn/user/get-user-profiles-where-is-auditor';
import { GetUserProfilesWhereIsAuditor$Params } from '../fn/user/get-user-profiles-where-is-auditor';
import { getUserProfilesWhereIsReporter } from '../fn/user/get-user-profiles-where-is-reporter';
import { GetUserProfilesWhereIsReporter$Params } from '../fn/user/get-user-profiles-where-is-reporter';
import { getUserProfilesWhereIsViewer } from '../fn/user/get-user-profiles-where-is-viewer';
import { GetUserProfilesWhereIsViewer$Params } from '../fn/user/get-user-profiles-where-is-viewer';
import { getUserTokens } from '../fn/user/get-user-tokens';
import { GetUserTokens$Params } from '../fn/user/get-user-tokens';
import { inviteNotExistingUserToProfile } from '../fn/user/invite-not-existing-user-to-profile';
import { InviteNotExistingUserToProfile$Params } from '../fn/user/invite-not-existing-user-to-profile';
import { listProfileIdeas } from '../fn/user/list-profile-ideas';
import { ListProfileIdeas$Params } from '../fn/user/list-profile-ideas';
import { listProfileRandomForUser } from '../fn/user/list-profile-random-for-user';
import { ListProfileRandomForUser$Params } from '../fn/user/list-profile-random-for-user';
import { LoginTokens } from '../models/login-tokens';
import { loginWithCode } from '../fn/user/login-with-code';
import { LoginWithCode$Params } from '../fn/user/login-with-code';
import { MailChimpStatusResponse } from '../models/mail-chimp-status-response';
import { NewsFeedUnSeenResponse } from '../models/news-feed-un-seen-response';
import { newsletterStatus } from '../fn/user/newsletter-status';
import { NewsletterStatus$Params } from '../fn/user/newsletter-status';
import { patchUser } from '../fn/user/patch-user';
import { PatchUser$Params } from '../fn/user/patch-user';
import { ProfileIdeaResponse } from '../models/profile-idea-response';
import { ProfileMemberResponse } from '../models/profile-member-response';
import { ProfileResponse } from '../models/profile-response';
import { ProfileSimple } from '../models/profile-simple';
import { ProfileSubscription } from '../models/profile-subscription';
import { ProfileToken } from '../models/profile-token';
import { ResponseGalleryImage } from '../models/response-gallery-image';
import { updateUser } from '../fn/user/update-user';
import { UpdateUser$Params } from '../fn/user/update-user';
import { updateUserCoverById } from '../fn/user/update-user-cover-by-id';
import { UpdateUserCoverById$Params } from '../fn/user/update-user-cover-by-id';
import { updateUserLogoById } from '../fn/user/update-user-logo-by-id';
import { UpdateUserLogoById$Params } from '../fn/user/update-user-logo-by-id';
import { UserFollowingProfile } from '../models/user-following-profile';
import { UserResponse } from '../models/user-response';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `loginWithCode()` */
  static readonly LoginWithCodePath = '/rest/user/login/code';

  /**
   * Log in user with.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginWithCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithCode$Response(params: LoginWithCode$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginTokens>> {
    return loginWithCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Log in user with.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginWithCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithCode(params: LoginWithCode$Params, context?: HttpContext): Observable<LoginTokens> {
    return this.loginWithCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginTokens>): LoginTokens => r.body)
    );
  }

  /** Path part for operation `getMe()` */
  static readonly GetMePath = '/rest/user/me';

  /**
   * Get logged user information (by JWT token).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMe$Response(params?: GetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return getMe(this.http, this.rootUrl, params, context);
  }

  /**
   * Get logged user information (by JWT token).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMe(params?: GetMe$Params, context?: HttpContext): Observable<UserResponse> {
    return this.getMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `changeUserPassword()` */
  static readonly ChangeUserPasswordPath = '/rest/user/change-password';

  /**
   * Change user password - only for logged user. Required is valid old password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeUserPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeUserPassword$Response(params: ChangeUserPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return changeUserPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Change user password - only for logged user. Required is valid old password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeUserPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeUserPassword(params: ChangeUserPassword$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.changeUserPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `changeNotificationsStatus()` */
  static readonly ChangeNotificationsStatusPath = '/rest/user/notifications';

  /**
   * Change notification status of user (for emails). If user has activated notifications, they will be disabled (vice versa).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeNotificationsStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  changeNotificationsStatus$Response(params?: ChangeNotificationsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return changeNotificationsStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Change notification status of user (for emails). If user has activated notifications, they will be disabled (vice versa).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeNotificationsStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  changeNotificationsStatus(params?: ChangeNotificationsStatus$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.changeNotificationsStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `newsletterStatus()` */
  static readonly NewsletterStatusPath = '/rest/user/newsletter';

  /**
   * Get status of user in newsletter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsletterStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsletterStatus$Response(params?: NewsletterStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<MailChimpStatusResponse>> {
    return newsletterStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Get status of user in newsletter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsletterStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsletterStatus(params?: NewsletterStatus$Params, context?: HttpContext): Observable<MailChimpStatusResponse> {
    return this.newsletterStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<MailChimpStatusResponse>): MailChimpStatusResponse => r.body)
    );
  }

  /** Path part for operation `changeNewsletterStatus()` */
  static readonly ChangeNewsletterStatusPath = '/rest/user/newsletter';

  /**
   * Change newsletter status of user (for emails). If user has activated newsletter, they will be disabled (vice versa).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeNewsletterStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  changeNewsletterStatus$Response(params?: ChangeNewsletterStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<MailChimpStatusResponse>> {
    return changeNewsletterStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Change newsletter status of user (for emails). If user has activated newsletter, they will be disabled (vice versa).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeNewsletterStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  changeNewsletterStatus(params?: ChangeNewsletterStatus$Params, context?: HttpContext): Observable<MailChimpStatusResponse> {
    return this.changeNewsletterStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<MailChimpStatusResponse>): MailChimpStatusResponse => r.body)
    );
  }

  /** Path part for operation `findUsers()` */
  static readonly FindUsersPath = '/rest/user/search';

  /**
   * Find users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findUsers$Response(params: FindUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserResponse>>> {
    return findUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Find users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findUsers(params: FindUsers$Params, context?: HttpContext): Observable<Array<UserResponse>> {
    return this.findUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserResponse>>): Array<UserResponse> => r.body)
    );
  }

  /** Path part for operation `getUserById()` */
  static readonly GetUserByIdPath = '/rest/user/{id}';

  /**
   * Get user data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserById$Response(params: GetUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return getUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserById(params: GetUserById$Params, context?: HttpContext): Observable<UserResponse> {
    return this.getUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/rest/user/{id}';

  /**
   * Update data of user. If ID is not defined than update data of logged user - otherwise it updates data of user defined by id (admin permisions required).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return updateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Update data of user. If ID is not defined than update data of logged user - otherwise it updates data of user defined by id (admin permisions required).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<UserResponse> {
    return this.updateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `patchUser()` */
  static readonly PatchUserPath = '/rest/user/{id}';

  /**
   * Patch existing user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchUser$Response(params: PatchUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return patchUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Patch existing user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchUser(params: PatchUser$Params, context?: HttpContext): Observable<UserResponse> {
    return this.patchUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `getUserFollowingProfiles()` */
  static readonly GetUserFollowingProfilesPath = '/rest/user/{id}/profile/following';

  /**
   * Get profiles which user is following.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserFollowingProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserFollowingProfiles$Response(params: GetUserFollowingProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserFollowingProfile>>> {
    return getUserFollowingProfiles(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profiles which user is following.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserFollowingProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserFollowingProfiles(params: GetUserFollowingProfiles$Params, context?: HttpContext): Observable<Array<UserFollowingProfile>> {
    return this.getUserFollowingProfiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserFollowingProfile>>): Array<UserFollowingProfile> => r.body)
    );
  }

  /** Path part for operation `getUserProfilesWhereIsAdmin()` */
  static readonly GetUserProfilesWhereIsAdminPath = '/rest/user/{id}/profile/admin';

  /**
   * Get profiles where user is admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfilesWhereIsAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsAdmin$Response(params: GetUserProfilesWhereIsAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
    return getUserProfilesWhereIsAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profiles where user is admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfilesWhereIsAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsAdmin(params: GetUserProfilesWhereIsAdmin$Params, context?: HttpContext): Observable<Array<ProfileResponse>> {
    return this.getUserProfilesWhereIsAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileResponse>>): Array<ProfileResponse> => r.body)
    );
  }

  /** Path part for operation `getUserProfilesWhereIsReporter()` */
  static readonly GetUserProfilesWhereIsReporterPath = '/rest/user/{id}/profile/reporter';

  /**
   * Get profiles where user is reporter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfilesWhereIsReporter()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsReporter$Response(params: GetUserProfilesWhereIsReporter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
    return getUserProfilesWhereIsReporter(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profiles where user is reporter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfilesWhereIsReporter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsReporter(params: GetUserProfilesWhereIsReporter$Params, context?: HttpContext): Observable<Array<ProfileResponse>> {
    return this.getUserProfilesWhereIsReporter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileResponse>>): Array<ProfileResponse> => r.body)
    );
  }

  /** Path part for operation `getUserProfilesWhereIsAuditor()` */
  static readonly GetUserProfilesWhereIsAuditorPath = '/rest/user/{id}/profile/auditor';

  /**
   * Get profiles where user is auditor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfilesWhereIsAuditor()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsAuditor$Response(params: GetUserProfilesWhereIsAuditor$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
    return getUserProfilesWhereIsAuditor(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profiles where user is auditor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfilesWhereIsAuditor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsAuditor(params: GetUserProfilesWhereIsAuditor$Params, context?: HttpContext): Observable<Array<ProfileResponse>> {
    return this.getUserProfilesWhereIsAuditor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileResponse>>): Array<ProfileResponse> => r.body)
    );
  }

  /** Path part for operation `getUserProfilesWhereIsViewer()` */
  static readonly GetUserProfilesWhereIsViewerPath = '/rest/user/{id}/profile/viewer';

  /**
   * Get profiles where user is viewer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfilesWhereIsViewer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsViewer$Response(params: GetUserProfilesWhereIsViewer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
    return getUserProfilesWhereIsViewer(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profiles where user is viewer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfilesWhereIsViewer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfilesWhereIsViewer(params: GetUserProfilesWhereIsViewer$Params, context?: HttpContext): Observable<Array<ProfileResponse>> {
    return this.getUserProfilesWhereIsViewer$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileResponse>>): Array<ProfileResponse> => r.body)
    );
  }

  /** Path part for operation `getUserActiveSubscriptions()` */
  static readonly GetUserActiveSubscriptionsPath = '/rest/user/{id}/profile/subscriptions';

  /**
   * Get active subscriptions for profiles where user is admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserActiveSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserActiveSubscriptions$Response(params: GetUserActiveSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSubscription>>> {
    return getUserActiveSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get active subscriptions for profiles where user is admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserActiveSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserActiveSubscriptions(params: GetUserActiveSubscriptions$Params, context?: HttpContext): Observable<Array<ProfileSubscription>> {
    return this.getUserActiveSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileSubscription>>): Array<ProfileSubscription> => r.body)
    );
  }

  /** Path part for operation `getUserTokens()` */
  static readonly GetUserTokensPath = '/rest/user/{id}/profile/tokens';

  /**
   * Get tokens for all profiles where user is admin and has active subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserTokens()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserTokens$Response(params: GetUserTokens$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileToken>>> {
    return getUserTokens(this.http, this.rootUrl, params, context);
  }

  /**
   * Get tokens for all profiles where user is admin and has active subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserTokens$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserTokens(params: GetUserTokens$Params, context?: HttpContext): Observable<Array<ProfileToken>> {
    return this.getUserTokens$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileToken>>): Array<ProfileToken> => r.body)
    );
  }

  /** Path part for operation `updateUserLogoById()` */
  static readonly UpdateUserLogoByIdPath = '/rest/user/{id}/logo';

  /**
   * Update existing user logo by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserLogoById()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateUserLogoById$Response(params: UpdateUserLogoById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return updateUserLogoById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing user logo by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserLogoById$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateUserLogoById(params: UpdateUserLogoById$Params, context?: HttpContext): Observable<UserResponse> {
    return this.updateUserLogoById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `updateUserCoverById()` */
  static readonly UpdateUserCoverByIdPath = '/rest/user/{id}/cover';

  /**
   * Update existing user cover by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserCoverById()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateUserCoverById$Response(params: UpdateUserCoverById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return updateUserCoverById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing user cover by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserCoverById$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateUserCoverById(params: UpdateUserCoverById$Params, context?: HttpContext): Observable<UserResponse> {
    return this.updateUserCoverById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `galleryByUserId()` */
  static readonly GalleryByUserIdPath = '/rest/user/{id}/gallery';

  /**
   * Get list of gallery images for user (max 30). Gallery of user consist of activity images where user is organizer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryByUserId$Response(params: GalleryByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseGalleryImage>>> {
    return galleryByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of gallery images for user (max 30). Gallery of user consist of activity images where user is organizer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryByUserId(params: GalleryByUserId$Params, context?: HttpContext): Observable<Array<ResponseGalleryImage>> {
    return this.galleryByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseGalleryImage>>): Array<ResponseGalleryImage> => r.body)
    );
  }

  /** Path part for operation `activitiesByUserId()` */
  static readonly ActivitiesByUserIdPath = '/rest/user/{id}/activities';

  /**
   * Get list of activities where is organizer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activitiesByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  activitiesByUserId$Response(params: ActivitiesByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
    return activitiesByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of activities where is organizer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activitiesByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activitiesByUserId(params: ActivitiesByUserId$Params, context?: HttpContext): Observable<Array<ActivityResponse>> {
    return this.activitiesByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityResponse>>): Array<ActivityResponse> => r.body)
    );
  }

  /** Path part for operation `listProfileIdeas()` */
  static readonly ListProfileIdeasPath = '/rest/user/profile-idea';

  /**
   * List all profile ideas which user can see (user can see profile idea if is administrator of profile).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileIdeas()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileIdeas$Response(params?: ListProfileIdeas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileIdeaResponse>>> {
    return listProfileIdeas(this.http, this.rootUrl, params, context);
  }

  /**
   * List all profile ideas which user can see (user can see profile idea if is administrator of profile).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileIdeas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileIdeas(params?: ListProfileIdeas$Params, context?: HttpContext): Observable<Array<ProfileIdeaResponse>> {
    return this.listProfileIdeas$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileIdeaResponse>>): Array<ProfileIdeaResponse> => r.body)
    );
  }

  /** Path part for operation `countOfUnseenNewsFeedItems()` */
  static readonly CountOfUnseenNewsFeedItemsPath = '/rest/user/newsfeed/unseen';

  /**
   * Count of unseen newsfeed items.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countOfUnseenNewsFeedItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  countOfUnseenNewsFeedItems$Response(params?: CountOfUnseenNewsFeedItems$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedUnSeenResponse>> {
    return countOfUnseenNewsFeedItems(this.http, this.rootUrl, params, context);
  }

  /**
   * Count of unseen newsfeed items.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countOfUnseenNewsFeedItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countOfUnseenNewsFeedItems(params?: CountOfUnseenNewsFeedItems$Params, context?: HttpContext): Observable<NewsFeedUnSeenResponse> {
    return this.countOfUnseenNewsFeedItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsFeedUnSeenResponse>): NewsFeedUnSeenResponse => r.body)
    );
  }

  /** Path part for operation `listProfileRandomForUser()` */
  static readonly ListProfileRandomForUserPath = '/rest/profile/random-for-user/{max}/{following}/{minActivities}';

  /**
   * Get random list of profiles for logged user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileRandomForUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileRandomForUser$Response(params: ListProfileRandomForUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSimple>>> {
    return listProfileRandomForUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Get random list of profiles for logged user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileRandomForUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileRandomForUser(params: ListProfileRandomForUser$Params, context?: HttpContext): Observable<Array<ProfileSimple>> {
    return this.listProfileRandomForUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileSimple>>): Array<ProfileSimple> => r.body)
    );
  }

  /** Path part for operation `inviteNotExistingUserToProfile()` */
  static readonly InviteNotExistingUserToProfilePath = '/rest/profile/{id}/invite';

  /**
   * Invite user by email to profile (as admin, reporter, auditor or viewer). User will be created if there is no user with such email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteNotExistingUserToProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteNotExistingUserToProfile$Response(params: InviteNotExistingUserToProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileMemberResponse>> {
    return inviteNotExistingUserToProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Invite user by email to profile (as admin, reporter, auditor or viewer). User will be created if there is no user with such email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteNotExistingUserToProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteNotExistingUserToProfile(params: InviteNotExistingUserToProfile$Params, context?: HttpContext): Observable<ProfileMemberResponse> {
    return this.inviteNotExistingUserToProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileMemberResponse>): ProfileMemberResponse => r.body)
    );
  }

}
